import { combineReducers } from 'redux';
import osReducer from './serviceOrder';

export default combineReducers({
  OrderService: osReducer,
});
